"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAttributionEventResponseSchema = exports.CreateAttributionEventSchema = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.CreateAttributionEventSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    teamId: core_1.IdSchema,
    country: core_1.CountrySchema,
    channelType: ruby_1.ChannelTypeSchema,
    ...ruby_1.ExternalAttributionEventFields,
    ...core_1.CreateModelMetaFields,
}, {
    title: "New attribution event",
    description: "Attribution event relating to a campaign",
});
exports.GetAttributionEventResponseSchema = ruby_1.AttributionEventSchema;
